import { render, staticRenderFns } from "./DownloadPdfButton.vue?vue&type=template&id=3b406c7a&scoped=true&"
import script from "./DownloadPdfButton.vue?vue&type=script&lang=js&"
export * from "./DownloadPdfButton.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPdfButton.vue?vue&type=style&index=0&id=3b406c7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b406c7a",
  null
  
)

export default component.exports